import React, { useState, useEffect } from 'react';
import { memberService } from '../services/api';

const About = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await memberService.getAllMembers();
        setMembers(response.data);
      } catch (err) {
        setError('Failed to load members');
        console.error('Error:', err);
        setMembers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  if (loading) {
    return (
      <>
        <section className="hero about-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>About Us</h1>
            <p>We are a trusted company providing industrial solutions since 2025.</p>
          </div>
        </section>
        <div className="loading">
          <p>Loading Members...</p>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Hero Section */}
      <section className="hero about-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>About Us</h1>
          <p>We are a trusted company providing industrial solutions since 2025.</p>
        </div>
      </section>

      {/* Company Blog */}
      <section className="about-content">
        <div className="container">
          <h2>Our Journey</h2>
          <p>
            Aryan Engineerings is built on years of practical industrial experience and a strong
            commitment to delivering reliable engineering solutions. The journey began in 2007,
            when the foundation was laid through supplying industrial pumps and mechanical seals
            to various industries.
          </p>
          <p>
            Along with supply, extensive involvement in maintenance activities for steel plants
            and heavy industries provided deep exposure to real-world challenges such as equipment
            wear, leakage issues, downtime, and efficiency concerns.
          </p>
          <p>
            With nearly two decades of hands-on industry knowledge, Aryan Engineerings was officially
            established in 2025 with a clear objective — to provide high-quality pumps and mechanical
            sealing solutions that ensure operational reliability, efficiency, and long service life.
          </p>
        </div>
      </section>

      {/* Founder & CEO Blog */}
      <section className="about-content">
        <div className="container">
          <h2 className="single-line-heading">
            Founder & CEO – Mr. Nilesh Mahatole
          </h2>
          <p>
            Mr. Nilesh Prakash Mahatole began his professional journey in the industrial sector in 2007
            as a supplier of industrial pumps and mechanical seals. Working closely with various
            industries helped him gain a strong understanding of operational requirements and system
            performance.
          </p>
          <p>
            In addition to supply, he was actively involved in the maintenance of industrial equipment,
            particularly in steel plants and heavy industries. This hands-on exposure allowed him to
            understand pump failures, sealing challenges, maintenance planning, and efficiency
            optimization.
          </p>
          <p>
            With extensive field experience and technical expertise, he founded Aryan Engineerings in
            2025 with a vision to deliver dependable, industry-ready pumping and sealing solutions.
            Under his leadership, the company continues to grow with a focus on quality, reliability,
            and customer satisfaction.
          </p>
        </div>
      </section>

      {/* Company & Members Section */}
      <section className="company-engineer-section">
        <div className="container company-engineer-container">
          <div className="company-info">
            <h2>About the Company</h2>
            <p>
              Aryan Engineerings specializes in mechanical shaft seals and chemical process pumps,
              providing high-quality industrial solutions tailored to demanding applications across
              chemical, pharmaceutical, petrochemical, and manufacturing sectors.
            </p>
            <p>
              Our strength lies in combining product quality with technical expertise and customer-
              focused service to ensure long-term operational reliability.
            </p>
          </div>

          {/* Dynamic Members Section */}
          {members.length > 0 && (
            <div className="members-grid">
              {members.map((member) => (
                <div key={member.id} className="member-info-wrapper">
                  <div className="member-photo">
                    <img
                      src={member.photo || "/images/member-photo-placeholder.png"}
                      alt={member.name}
                    />
                  </div>
                  <div className="member-details">
                    <h3>{member.name}</h3>
                    {member.position && <h4>{member.position}</h4>}  
                    <p>{member.description}</p>
                  </div>
                </div>
              ))}
            </div>
          )}

          {error && (
            <div style={{ color: 'red', padding: '20px', textAlign: 'center' }}>
              {error}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default About;
